import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "signup-page mx-auto p-3 w-330" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "my-4 text-center" }, "用户注册", -1)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "用户名", -1)
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "手机号码", -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "邮箱地址 (可选)", -1)
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "地址 (可选)", -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "类别", -1)
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "密码", -1)
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "重复密码", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary btn-block btn-large mt-2 mb-4"
}, "注册", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_validate_input = _resolveComponent("validate-input")!
  const _component_validate_select = _resolveComponent("validate-select")!
  const _component_validate_form = _resolveComponent("validate-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_validate_form, { onFormSubmit: _ctx.onFormSubmit }, {
      submit: _withCtx(() => [
        _hoisted_17
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_validate_input, {
            class: "form-control",
            rules: _ctx.usernameRules,
            modelValue: _ctx.formData.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.username) = $event)),
            placeholder: "请输入用户名",
            type: "text"
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_validate_input, {
            class: "form-control",
            rules: _ctx.mobileRules,
            modelValue: _ctx.formData.mobile,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.mobile) = $event)),
            placeholder: "请输入手机号码",
            type: "text"
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_validate_input, {
            class: "form-control",
            modelValue: _ctx.formData.email,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.email) = $event)),
            placeholder: "请输入邮箱地址",
            type: "text"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_validate_input, {
            class: "form-control",
            modelValue: _ctx.formData.address,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.address) = $event)),
            placeholder: "请输入地址",
            type: "text"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_validate_select, {
            rules: _ctx.typeRules,
            modelValue: _ctx.formData.type,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.type) = $event)),
            content: ['公司', '个人']
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_validate_input, {
            class: "form-control",
            type: "password",
            placeholder: "请输入密码",
            rules: _ctx.passwordRules,
            modelValue: _ctx.formData.password,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.password) = $event))
          }, null, 8, ["rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_validate_input, {
            class: "form-control",
            type: "password",
            placeholder: "请再次输入密码",
            rules: _ctx.repeatPasswordRules,
            modelValue: _ctx.formData.repeatPassword,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.repeatPassword) = $event))
          }, null, 8, ["rules", "modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["onFormSubmit"])
  ]))
}